import React from 'react';
export const FeatureSwitchContext = React.createContext({});
export const { Consumer: FeatureSwitchConsumer, Provider: FeatureSwitchProvider } = FeatureSwitchContext;
//# sourceMappingURL=feature-switches-context.js.map